import { DefaultHubColors } from "../interfaces";
import { pickTextColor } from "../utils/color_helpers";

type Props = {
  colorHex?: string
  title?: string
}

export const Navbar = ({ colorHex = DefaultHubColors.primary, title = "KiwiTicket" }: Props) => (
  <nav className='flex items-center flex-wrap px-8 py-1.5 filter drop-shadow-md' style={{ backgroundColor: colorHex }}>
    <a className='inline-flex items-center p-2 mr-4 hover:bg-white hover:bg-opacity-20 x-3 py-2 rounded'>
      <span className='text-xl tracking-wide' style={{ color: pickTextColor(colorHex, 'white', 'black') }}>
        {title}
      </span>
    </a>
  </nav>
);
